import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Children, isValidElement } from 'react';
import { getSidebarCategory } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
const useSelectedAddCategory = children => {
  const selectedSidebarCategory = useSelector(getSidebarCategory);
  const childArray = Children.toArray(children);
  return childArray.find(child => /*#__PURE__*/isValidElement(child) && child.props.name === selectedSidebarCategory);
};
export default function PatagoniaAddCategoryContainer({
  children
}) {
  const selectedCategory = useSelectedAddCategory(children);
  return selectedCategory;
}
PatagoniaAddCategoryContainer.propTypes = {
  children: PropTypes.node.isRequired
};